// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3_azu","overflowing":"ReadFullNote_overflowing__2sNNX"};